import { render, staticRenderFns } from "./sky-textarea.vue?vue&type=template&id=043a2260&scoped=true"
import script from "./sky-textarea.vue?vue&type=script&lang=js"
export * from "./sky-textarea.vue?vue&type=script&lang=js"
import style0 from "./sky-textarea.vue?vue&type=style&index=0&id=043a2260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043a2260",
  null
  
)

export default component.exports